import { render, staticRenderFns } from "./shushuo.vue?vue&type=template&id=346ebbde&"
import script from "./shushuo.vue?vue&type=script&lang=js&"
export * from "./shushuo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports